import { InfoInput } from '@p2p/components';
import { PaymentType } from '@p2p/shared/constants';

import { useDeepLink } from '../../DeepLink/useDeepLink';
import { TransferRequisitesProps } from './TransferRequisites.types';

export const TransferRequisites = ({ order }: TransferRequisitesProps) => {
  const { isRmFlow } = useDeepLink({ order });
  const inputTransferLabel = isRmFlow ? 'Номер договора' : 'Номер счета';

  if (order.requisite.payment_type !== PaymentType.PAYMENT_TYPE_TRANSFER) {
    return null;
  }

  return (
    <>
      <InfoInput label={inputTransferLabel} value={order.requisite.account_number} canCopy />
      {!isRmFlow && <InfoInput label="БИК" value={order.requisite.bic} canCopy />}
      <InfoInput label="Банк получателя" value={order.requisite.bank.name || 'Банк не найден'} />
      <InfoInput label="Получатель" value={order.requisite.fio} />
      {/* P2P-2595: раньше здесь был статичный текст "Перевод" независимо от того, что
          реально пришло в requisite.purpose — теперь показываем настоящее назначение
          платежа (важно для ПСБ и любых других TRANSFER-реквизитов с заполненным purpose),
          с откатом на прежний плейсхолдер, если purpose не заполнен. */}
      <InfoInput label="Назначение платежа" value={order.requisite.purpose || 'Перевод'} />
    </>
  );
};
